/**
 * Default human-agent logo — inline SVG used on agent message rows.
 * Swap the markup here to rebrand the agent avatar across the app.
 *
 * @param {{ className?: string }} props
 */
export default function AgentLogoMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      role="img"
      aria-label="Agent"
      className={`h-full w-full ${className}`.trim()}
    >
      <rect x="0" y="0" width="32" height="32" rx="9" fill="#0f766e" />
      <circle cx="16" cy="12.5" r="4.2" fill="#ccfbf1" />
      <path
        d="M8.5 25.5c0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5"
        fill="#ccfbf1"
      />
      <path
        d="M7.5 14.5c0-2.2 1.8-3.2 3.2-3.2h.8"
        fill="none"
        stroke="#99f6e4"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M24.5 14.5c0-2.2-1.8-3.2-3.2-3.2h-.8"
        fill="none"
        stroke="#99f6e4"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <rect x="6.8" y="14.8" width="2.4" height="3.6" rx="1.2" fill="#99f6e4" />
      <rect x="22.8" y="14.8" width="2.4" height="3.6" rx="1.2" fill="#99f6e4" />
    </svg>
  );
}
